import CheckUser from "../components/checkUser/CheckUser.vue";

let routes = {
    path: "/checkUser",
    component: resolve => require(["../components/layout/App"], resolve),
    children: [
        {
            path: "/checkUser",
            name: "Visualizar Colaborador",
            component: CheckUser
        },
    ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/checkUser.js